module.exports = __webpack_public_path__ + "static/media/sortByInline.2baa06e0.svg";